import { whatsapp } from "react-icons-kit/icomoon/whatsapp";
import { phone } from "react-icons-kit/icomoon/phone";
import { location } from "react-icons-kit/icomoon/location";
import { facebook } from "react-icons-kit/icomoon/facebook";
import { share2 } from "react-icons-kit/icomoon/share2";
import { instagram } from "react-icons-kit/icomoon/instagram";
import { instagram as instagram1 } from 'react-icons-kit/fa/instagram';
import { youtubePlay } from 'react-icons-kit/fa/youtubePlay';
import { envelopeO } from 'react-icons-kit/fa/envelopeO';
import { sphere } from 'react-icons-kit/icomoon/sphere';
import { chatbubble } from 'react-icons-kit/ionicons/chatbubble';


const icons = { whatsapp, phone, location, facebook, share2, instagram , instagram1 ,  youtubePlay , envelopeO , sphere , chatbubble };

export default icons;